export default "<p>Exportez l'historique du Beeping en Format .csv</p>\n<button (click)=\"download()\">Telecharger</button>\n"